<template >
   
  <div class="main-tabs-content" >
    <!-- header area-->
    <div class="tabs-layout-header">
      <div class="tabs-layout-header-items w-full">
        <div class="items-left">
          <ul class="items-list" v-if="lcaDetails.petitionDetails">
            <li>
              Case Type
              <span
                >{{
                  checkProperty(
                    lcaDetails.petitionDetails,
                    "typeDetails",
                    "name"
                  )
                }}
                -
                {{
                  checkProperty(
                    lcaDetails.petitionDetails,
                    "subTypeDetails",
                    "name"
                  )
                }}</span
              >
            </li>
            <li>
              Created
              <span>{{
                checkProperty(lcaDetails, "createdOn") | formatDateTime
              }}</span>
            </li>
            <!--
            <li>
              Last Updated
              <span>{{
                checkProperty(lcaDetails, "updatedOn") | formatDateTime
              }}</span>
            </li>
            -->
            <li>
              LCA Number
              <span>{{ checkProperty(lcaDetails, "caseNo") }}</span>
            </li>
          </ul>
        </div>

        <div class="items-right">
          <ul>
            <li v-if="lcaDetails.statusDetails">
              <div class="dropdown-button-container">
             
                <vs-button>
                  <span 
                  
                  v-bind:class="{
                    'status_registered': lcaDetails.statusDetails.id == 1,
                    'status_filed': lcaDetails.statusDetails.id == 2,
                    'status_certified': lcaDetails.statusDetails.id == 3,
                    'status_denied':lcaDetails.statusDetails.id == 4,
                    'status_request_for_withdrawal':lcaDetails.statusDetails.id == 5,
                    'status_withdrawn:lcaDetails':lcaDetails.statusDetails.id == 6,
                    'status_expired':lcaDetails.statusDetails.id == 7,
                  }"
                  
                  >{{
                    lcaDetails.statusDetails.name
                  }}</span>
                </vs-button>
                <vs-dropdown
                  vs-custom-content
                  vs-trigger-click
                  v-if="lcaDetails.submitedByRole != 50 && [1 ,2].indexOf(lcaDetails.statusDetails.id)>-1" 
                >
                  <vs-button
                    class="btn-drop"
                    :disabled="lcaDetails.statusDetails.id == 3" 
                  > 
                    Actions
                    <i class="material-icons">arrow_drop_down</i> 
                  </vs-button>
                  <vs-dropdown-menu
                    class="actions-dropdown"
                    v-if="[1 ,2].indexOf(lcaDetails.statusDetails.id)>-1"
                  >
                    <template v-for="(item, index) in allLcaStatuses">
                        <template v-if="[1,2,3].indexOf(item.id)>-1">
                          <vs-dropdown-item
                            v-if="item.id > lcaDetails.statusDetails.id"
                            :key="index"
                          >
                          <!---
                          
                          
                          ---->
                            <vs-checkbox
                            :disabled="
                                //(item.id == 3 && lcaDetails.statusDetails.id < 2) ||
                                (item.id == 4 && lcaDetails.statusDetails.id < 2)
                                
                              "
                              
                              @click="updatestatus(index, item.name, item.id)"
                              >{{ item.name }}</vs-checkbox
                            >
                          </vs-dropdown-item>
                        </template>
                    </template>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </li>
            <li style="display: none">
              <template lang="html">
                <div id="parentx">
                  <img
                    @click.stop="active = true"
                    class="cursor-pointer"
                    src="@/assets/images/main/settings.svg"
                  />
                  <vs-sidebar
                    position-right
                    parent="body"
                    default-index="1"
                    class="sidebarx history-sidebar"
                    spacer
                    v-model="active"
                  >
                    <!-- <vs-sidebar> -->
                    <div class="header-sidebar" slot="header">
                      <h4>LCA Activities</h4>
                      <figure @click="active = !active">
                        <img src="@/assets/images/main/icon-remove.svg" />
                      </figure>
                    </div>
                    <VuePerfectScrollbar
                      class="scroll-area"
                      v-once
                      @ps-scroll-y="scrollHandle"
                    >
                      <div class="timeline-sidebar">
                        <ul>
                          <li
                            v-for="(item, index) in activityList"
                            :key="index"
                          >
                            <div class="timeline-icon">
                              <i class="icon IP-tick-sign"></i>
                            </div>
                            <div class="timeline-info">
                              <button class="btn active-green ml-0">
                                {{ item.createdByRoleName }}
                              </button>
                              <ul>
                                <li>
                                  <h3>{{ item.title }}</h3>
                                  <p>{{ item.description }}</p>
                                  <span>{{
                                    item.createdOn | formatDateTime
                                  }}</span>
                                </li>
                              </ul>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </VuePerfectScrollbar>
                  </vs-sidebar>
                </div>
              </template>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- content section start here-->

  

    <div class="tabs-content">
      <div class="tab-inner-content otherlcacontent">
        <LCADetails
          v-if="lcaDetails != null "
          v-bind:petition="petition"
          @download_or_view="download_or_view"
          v-bind:currentRole="currentRole"
          v-bind:lcaDetails="lcaDetails"
        />
      </div>
    </div>
      <vs-popup
      class="holamundo main-popup"
      :title="'Update LCA - ' + lcastatusSelected.statusName + ''"
      :active.sync="lcaUpdateForm"
      v-if="lcaUpdateForm"
    >
      <form data-vv-scope="approveparalegalfoform">
        <div class="form-container">
          <div class="vx-row">
            <div class="vx-col md:w-1/2" v-if="this.lcastatusSelected.id == 2">
              <div class="form_group" >
                <label class="form_label">DOL Reference Number<em>*</em></label>
                 <div class="vs-component w-full">
                <vs-input :key="'lcaNumber'"
                  name="lcaNumber"
                  :disabled="lcaDetails.number"
                  v-model="number"
                  data-vv-as="DOL Reference Number"
                  v-validate="'required'"
                  placeholder="DOL Reference Number"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('approveparalegalfoform.lcaNumber')"
                  >{{ errors.first("approveparalegalfoform.lcaNumber") }}</span
                >
                 </div>
              </div>
            </div>
            <div class="vx-col w-full" v-if="this.lcastatusSelected.id == 2">
                <div class="form_group" >
                <label class="form_label">Filed Date<em>*</em></label>
                <div class="vs-component">
                  <datepicker  :typeable="true"
                    name="filedDate"
                    :disabled-dates="{ from: new Date() }"
                    v-validate="'required'"
                    v-model="filedDate"
                    data-vv-as="Filed Date"
                    placeholder="MM/DD/YYYY"
                  ></datepicker>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('approveparalegalfoform.filedDate')"
                  >
                    {{ errors.first("approveparalegalfoform.filedDate") }}
                  </span>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/2" v-if="lcaDetails && this.lcastatusSelected.id == 3">
              <div class="form_group">
                <label class="form_label">Certified Date<em>*</em></label>
                <div class="vs-component">
                  <datepicker  :typeable="true"
                    name="certifiedDate"
                    :disabled-dates="{ from: new Date() }"
                    v-validate="'required'"
                    v-model="certifiedDate"
                    data-vv-as="Certified Date"
                    placeholder="MM/DD/YYYY"
                  ></datepicker>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('approveparalegalfoform.certifiedDate')"
                  >
                    {{ errors.first("approveparalegalfoform.certifiedDate") }}
                  </span>
                </div>
              </div>
            </div> 
          </div>
          <div class="vx-row">
           <template v-if="this.lcastatusSelected.id == 2 || this.lcastatusSelected.id ==3" >
            <div class="vx-col w-full">
              
              <div class="form_group upload__block">
                <div class="vs-component" @click="uploading = false">
                  <file-upload
                  @updateData="updateData"
                    data-vv-as="Document"
                    v-validate="{ required: validateLcaFiles }"
                    :multiple="true" :hideSelected="true"
                    v-model="documents"
                    class="file-upload-input"
                    name="certifiedLca"
                    :accept="allDocEntity"
                   
                  >
                  <!-- @input="uploadLcaDocuments(documents)" -->
                    <img
                      class="file-icon"
                      src="@/assets/images/main/file-upload.svg"
                    />
                    Upload 
                  </file-upload>
                  <span v-if="uploading" class="loader"
                    ><img src="@/assets/images/main/loader.gif"
                  /></span>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('approveparalegalfoform.certifiedLca')"
                    >{{
                      errors.first("approveparalegalfoform.certifiedLca")
                    }}</span
                  >
                </div>
                <!---
                        <div class="file_view" v-for="(file, fileindex) in documents" :key="fileindex">{{file.name}}
                          <span  style="cursor:pointer"  @click="remove(fileindex, documents)"><i class="vs-icon notranslate icon-scale material-icons null">clear</i></span>
                     
                        </div>
                        -->

                <ul class="uploaded-list">
                  <template v-for="(file, fileindex) in lcaDocuments">
                    <vs-chip
                      type="button"
                      @click="removeLcaDocument(fileindex, lcaDocuments)"
                      :key="fileindex"
                      v-if="file.status !== false"
                      closable
                      >{{ file.name }}
                    </vs-chip>
                  </template>
                </ul>
              </div>
            </div>
           </template>

            <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Comments<em>*</em></label>
                <!-- <vs-textarea
                  data-vv-as="Comments"
                  v-validate="'required'"
                  v-model="actioncomment"
                  name="actioncomment"
                  class="w-full"
                /> -->
                <ckeditor data-vv-as="Comments"
                  v-validate="'required'"
                  v-model="actioncomment"
                  name="actioncomment"
                  class="w-full"  :editor="editor" :config="editorConfig"></ckeditor>

                <span
                  class="text-danger text-sm"
                  v-show="errors.has('approveparalegalfoform.actioncomment')"
                  >{{
                    errors.first("approveparalegalfoform.actioncomment")
                  }}</span
                >
              </div>
            </div>
          </div>
          <div
            class="text-danger text-sm formerrors"
            v-if="paralegalformerrors != ''"
          >
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ paralegalformerrors }}</vs-alert
            >
          </div>
        </div>

        <div class="popup-footer">
          <vs-button
            color="success"
            :disabled="disabled_btn"
            @click="updateLca"
            class="save"
            type="filled"
            >Submit</vs-button
          >
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<!--for active tab-->

<script>

import moment from "moment";
//import FileUpload from "vue-upload-component/src";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import LCADetails from "./LCADetails";
import * as _ from "lodash";
import Vue from 'vue';
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import FileUpload from "@/views/FileUpload.vue";
import Datepicker from "vuejs-datepicker-inv";

export default {
  components: {
    VuePerfectScrollbar,
    FileUpload,
    LCADetails,
    Datepicker,
  },
  name: "app",
  methods: {
    updateData(docs){
      this.lcaDocuments = docs
    },
   
     checkDocuments(){
     
      let documents = _.filter( this.lcaDocuments , { 'status':true });
      if(documents && documents.length>0){

        this.validateLcaFiles = false;
      }else{
         this.validateLcaFiles = true;
      }
    },
    uploadLcaDocuments(model) {

            let temp_count = 0;
          
            this.disabled_btn = true;
            let mapper = model.map(
                item =>
                (item = {
                    name: item.name,
                    file: item.file ? item.file : null,
                    path: item.path ? item.path : "",
                    status: item.status === false || item.status === true ?
                        item.status : true,
                    statusId: this.lcastatusSelected['id'] ? this.lcastatusSelected['id'] : '',
                    certified: this.lcastatusSelected.id == 3 ? true : false,
                    mimetype: item.type ? item.type : item.mimetype,
                    comment:this.actioncomment?this.actioncomment:''
                })
            );
             //this.$vs.loading();
             this.uploading =true;
             if (mapper.length > 0) {
                mapper.forEach((doc, index) => {
                    let formData = new FormData();
                    formData.append("files", doc.file);
                    formData.append("secureType", "private");
                    this.$store.dispatch("uploadS3File", formData).then(response => {
                        temp_count++;
                        response.data.result.forEach(urlGenerated => {

                            
                            doc.status = true;
                            doc.path = urlGenerated;
                            delete doc.file;
                            this.lcaDocuments.push(doc);
                            mapper[index] = doc;
                            if (temp_count >= mapper.length) {
                                this.disabled_btn = false;
                               // this.$vs.loading.close();
                                this.documents =[];
                                  this.uploading =false;
                            }
                            this.checkDocuments();

                        });
                    });

                });
                model.splice(0, mapper.length, ...mapper);
            }
    },

    removeLcaDocument(index, type){
      let selectedItemPath = this.lcaDocuments[index]['path'];
      let dbDocuments =[];
     if(this.lcaDetails.statusId == 2){
         dbDocuments = this.lcaDetails['documents']['filed'];
       }else if(this.lcaDetails.statusId == 3){
          dbDocuments = this.lcaDetails['documents']['certified'];
       }

       if(dbDocuments.length>0 && _.find(dbDocuments , {"path":selectedItemPath  }) ){

          //this.lcaDocuments[index]['status'] =false;
          Object.assign(this.lcaDocuments[index] ,{ "status":false})

       }else{
        let doc=type[index]
         type.splice(type.indexOf(index), 1);
         this.removeFileFromS3(doc)
       }
       
    
      this.checkDocuments();
        return true;
    },

     selectLcaStatus(item){
        
       
         if(this.lcastatusSelected.id == 2){
         this.lcaDocuments = this.lcaDetails['documents']['filed'];
       }else if(this.lcastatusSelected.id == 3){
          this.lcaDocuments = this.lcaDetails['documents']['certified'];
       }
       this.checkDocuments();
        
    },
    openLcaUpdatePopup(){
      //lcastatuses
      // filed:[],
      //certified:[]
       this.number =''
        this.documents = [];
      this.actioncomment = '';
      this.filedDate =null;
      this.certifiedDate = null ; 
     this.paralegalformerrors ='';
      this.documents = [];
      
     
      if(this.lcaDetails){
        //this.lcastatusSelected = _.find(this.allLcaStatuses ,{ "id": this.lcaDetails.statusId });
    //    alert(JSON.stringify(this.lcastatusSelected));
        this.selectLcaStatus( this.lcastatusSelected);
        if(_.has(this.lcaDetails ,'number')){
          this.number = this.lcaDetails.number;
        }

        //let  filedDate =  moment(this.filedDate).format("YYYY-MM-DD");  //filedDate certifiedDate this.lcastatusSelected.id ==
        if(_.has(this.lcaDetails ,"filedDate") ){
          this.filedDate = moment(this.lcaDetails['filedDate']).format("YYYY-MM-DD");

        }

        if(_.has(this.lcaDetails ,"certifiedDate")){
          this.certifiedDate = moment(this.lcaDetails['certifiedDate']).format("YYYY-MM-DD");

        }
        
      
      }
       this.lcaDocuments =[];
        this.lcaUpdateForm =true;
       // this.checkDocuments();
       //this.$validator.reset("approveparalegalfoform");
       this.$validator.reset();
       

    },
    updateLca() {
             this.paralegalformerrors ='';
            this.$validator.validateAll("approveparalegalfoform").then(result => {
              this.lcastatusSelected.lcaId  =this.lcaDetails['_id'];
              
                if (result) {
                     if([2,3].indexOf(this.lcastatusSelected.id) >-1){

                       let updatedValue = {
                            lcaId: this.lcaDetails._id,
                            number: this.number,
                            caseNo: this.lcaDetails.petitionDetails.caseNo,
                            action: "LCA_SUBMIT",
                            actionTitle:"Basic information updated",
                            innerAction:'UPDATE_DETAILS_AND_DOCUMENTS',
                            updateType: "details-and-documents",
                            statusName: this.lcastatusSelected.statusName,
                            statusId: this.lcastatusSelected.id,
                            comment: this.actioncomment,
                            actionDescription:this.actioncomment,
                            documents: this.lcaDetails['documents'],
                            today: moment().format("YYYY-MM-DD"),


                        };
                       // alert(JSON.stringify(updatedValue));
                        //filedDate certifiedDate this.lcastatusSelected.id ==
                          if(updatedValue.statusId == 2){

                            updatedValue['documents']['filed']= this.lcaDocuments;
                                                    

                        }else if(updatedValue.statusId == 3){

                            updatedValue['documents']['certified']= this.lcaDocuments;
                            
                          
                        }
                        if(this.filedDate){
                            let  filedDate =  moment(this.filedDate).format("YYYY-MM-DD");  //filedDate certifiedDate this.lcastatusSelected.id ==
                             Object.assign(updatedValue ,{ "filedDate": filedDate });
                        }
                        if(this.certifiedDate){
                          let  certifiedDate =  moment(this.certifiedDate).format("YYYY-MM-DD");
                            Object.assign(updatedValue ,{ "certifiedDate":certifiedDate  });

                        }

                        if([2].indexOf(this.lcastatusSelected.id) >-1){
                          Object.assign(updatedValue ,{ "certifiedDate": null });

                        } else if([3].indexOf(this.lcastatusSelected.id) >-1){
                          Object.assign(updatedValue ,{ "filedDate": null });

                        } 


                            this.disabled_btn =true;
                        this.$store.dispatch("updateLcaDetails", updatedValue).then(response => {
                          this.lcaUpdateForm = false;
                          this.showToster({message:this.checkProperty(response , 'data' ,'message'),isError:false })
                          setTimeout(() =>{
                            // this.$router.go(this.$route.name);
                            this.init()
                            
                         }, 200)
                         

                        })
                        .catch(error => {
                           this.disabled_btn =false;
                          this.paralegalformerrors =error;
                        })

                     }else{
                          let postData = {
                          lcaId:this.lcaDetails._id,
                          statusId: this.lcastatusSelected['id'],
                          statusName: this.lcastatusSelected['statusName'],
                          comment: this.actioncomment

                          };
                           this.disabled_btn =true;
                          this.$store.dispatch("updateLcaStatus", postData)
                          .then((response) => {

                          
                          this.lcaUpdateForm = false;
                          this.actioncomment ='';
                          this.showToster({message:this.checkProperty(response , 'data' ,'message'),isError:false })
                         setTimeout(() =>{
                            // this.$router.go(this.$route.name);
                              this.init()
                         }, 200)
                        


                          })
                          .catch(error => {
                             this.disabled_btn =false;
                          this.paralegalformerrors =error;
                          })
                     }
                        
                    

                    
                }
            })

        },

    download_or_view(value) {
      if (_.has(value, "path")) {
        value["url"] = value["path"];
        value["document"] = value["path"];
      }

      if (_.has(value, "url")) {
        value["path"] = value["url"];
        value["document"] = value["url"];
      }

      if (_.has(value, "document")) {
        value["path"] = value["document"];
        value["url"] = value["document"];
      }

      this.selectedFile = value;
      this.docValue = "";
      this.docPrivew = false;
      this.docType = false;
      this.docType = this.findmsDoctype(value);
       this.downloads3file(value);
      /*

      if (this.docType == "office" || this.docType == "image") {
        value.url = value.url.replace(this.$globalgonfig._S3URL, "");
        value.url = value.url.replace(this.$globalgonfig._S3URLAWS, "");
        let postdata = { keyName: value.url };
        this.$store.dispatch("getSignedUrl", postdata).then((response) => {
          this.docValue = response.data.result.data;

          if (this.docType == "office") {
            this.docValue = encodeURIComponent(response.data.result.data);
          }
          this.docPrivew = true;
        });
      } else {
        this.downloads3file(value);
      }
     */ 
    },
    fetchSignedUrl(value) {
      value.url = value.url.replace(this.$globalgonfig._S3URL, "");
      value.url = value.url.replace(this.$globalgonfig._S3URLAWS, "");
      let postdata = {
        keyName: value.url,
      };
      this.$store.dispatch("getSignedUrl", postdata).then((response) => {
        window.open(response.data.result.data, "_blank");
      });
    },
    scrollHandle(evt) {},
    upload(model) {
      let temp_count = 0;
      let formData = new FormData();
      this.disabled_btn = true;
      let mapper = model.map(
        (item) =>
          (item = {
            name: item.name,
            file: item.file ? item.file : null,
            url: item.url ? item.url : "",
            path: item.path ? item.path : "",
            status:
              item.status === false || item.status === true
                ? item.status
                : true,
            statusId: this.lcastatusSelected["id"]
              ? this.lcastatusSelected["id"]
              : "",
            certified: this.lcastatusSelected.id == 3 ? true : false,
            mimetype: item.type ? item.type : item.mimetype,
            comment: this.actioncomment ? this.actioncomment : "",
            uploadedBy:this.checkProperty(this.getUserData,'userId'),
            uploadedByName:this.checkProperty(this.getUserData,'name'),
            uploadedByRoleId:this.getUserRoleId,
            uploadedByRoleName:this.checkProperty(this.getUserData,'loginRoleName'),
          })
      );
      this.$vs.loading();

      if (mapper.length > 0) {
        mapper.forEach((doc, index) => {
          formData.append("files", doc.file);
          formData.append("secureType", "private");
          this.$store.dispatch("uploadS3File", formData).then((response) => {
            temp_count++;
            response.data.result.forEach((urlGenerated) => {
              if (temp_count >= mapper.length) {
                this.disabled_btn = false;
                this.$vs.loading.close();
              }

              doc.url = urlGenerated;
              doc.path = urlGenerated;
              delete doc.file;
              mapper[index] = doc;
            });
          });
        });
        model.splice(0, mapper.length, ...mapper);
      }
    },
    remove(item, type) {
      let doc=type[item]
      type.splice(item, 1);
      this.removeFileFromS3(doc)
      // item.status = false;
      // type[type.indexOf(item)] = item;
      // return false;
    },
    updatestatus(index, value, id) {
       
      this.lcastatusSelected = {
        lcaId: this.lcaDetails._id,
        id: id,
        statusId: index + 1,
        statusName: value,
      };
     
      this.openLcaUpdatePopup();
      
      
      
    },
    SubmitLcaForm() {
      this.$validator.validateAll("approveparalegalfoform").then((result) => {
        if (result) {
          if (this.lcastatusSelected.id == 2) {
            let updatedValue = {
              lcaId: this.lcaDetails._id,
              number: this.number,
              caseNo: this.lcaDetails.petitionDetails.caseNo,
              action: "UPDATE_BASIC_INFO",
              updateType: "lca-number",
              statusName: this.lcastatusSelected.name,
              comment: this.actioncomment,
            };

            this.$store
              .dispatch("updateLcaDetails", updatedValue)
              .then((response) => {});
          }

          if (
            this.documents.length > 0 &&
            (this.lcastatusSelected.id == 2 || this.lcastatusSelected.id == 3)
          ) {
            this.lcastatusSelected.document = this.documents;
            this.lcastatusSelected = Object.assign(this.lcastatusSelected, {
              documents: this.documents,
            });
            // this.lcastatusSelected.document[0]['comment'] =this.actioncomment
          }

          this.lcastatusSelected["comment"] = this.actioncomment;

          this.$store
            .dispatch("updateLcaStatus", this.lcastatusSelected)
            .then((response) => {
              if (response.status === 200) {
              }

              this.lcaForm = false;
              this.fetchDetails();
              this.fetchStatusMasterData();
              this.fetchActivityList();
            });

          // let updateFormsData = {
          //     documents: this.lcaDetails.documents,
          //     updateType: "documents",
          //     action: "UPLOAD_DOCUMENTS",
          //     lcaId: this.lcaDetails._id,
          //     comment: this.actioncomment,
          //     statusId: this.lcastatusSelected.id ? this.lcastatusSelected.id : ''
          // };

          // this.$store
          //     .dispatch("updateLcaDetails", updateFormsData)
          //     .then(response => {
          //         this.$vs.notify({
          //             title: "Success",
          //             text: response.message
          //         });
          //         this.lcaForm = false;
          //         this.fetchDetails();
          //         this.fetchStatusMasterData();
          //         this.fetchActivityList();

          //         // this.$router.go(this.$route.name);
          //     });
        }
      });
    },
    fetchDetails() {
      this.formsAndLetterSignedUrls = [];
       this.lcaDetails =null;
      this.$store
        .dispatch("fetchLcaDetails", this.$route.params.itemId)
        .then((response) => {
          this.lcaDetails = response.data.result;

          this.$store
            .dispatch("getpetition", this.lcaDetails.petitionDetails._id)
            .then((response) => {
              if (response.data) {
                this.petition = response.data.result;
              }
            });

          this.lcaDetails["status_documents"] = [];
          let stsid = this.lcaDetails["statusId"];

          let status_documents = {};
          let statusLogs = this.lcaDetails["statusLogs"];
          _.forEach(statusLogs, (object) => {
            let comment = object["comment"];
            let statusId = object["statusId"];
            _.forEach(this.lcaDetails["documents"].lca, (document, indx) => {
              this.lcaDetails["documents"].lca[indx]["is_new"] = false;

              let doc = _.cloneDeep(document);
              doc["comment"] = comment;

              if (
                doc["statusId"] &&
                doc["statusId"] == statusId &&
                doc["comment"] &&
                doc["comment"] != ""
              ) {
                if (_.has(status_documents, statusId)) {
                  status_documents[statusId].push(doc);
                } else {
                  status_documents[statusId] = [];
                  status_documents[statusId].push(doc);
                }
                document["is_status_document"] = true;
              } else {
                if (!document["is_status_document"])
                  document["is_status_document"] = false;
              }
            });
          });

          _.forEach(status_documents, (docs) => {
            if (docs.length > 0) {
              this.lcaDetails["status_documents"].push(docs);
            }
          });
        });
    },
    fetchStatusMasterData() {
      this.$store
        .dispatch("getmasterdata", "lca_inventory_status")
        .then((response) => {
          this.allLcaStatuses = response;
        });
    },
    fetchActivityList() {
      let postdata = {
        lcaId: this.$route.params.itemId,
        page: 1,
        perpage: 10,
      };
      
      this.$store.dispatch("fetchLCAactivities", postdata).then((response) => {
        this.activityList = response.data.result.list;
        
      });
     
    },
    init(){
        this.currentRole = this.$store.state.user.loginRoleId;

    this.fetchDetails();
    this.fetchStatusMasterData();
    this.fetchActivityList();
    }
  },
  data: () => ({
    editor: ClassicEditor,
 editorConfig: {
     toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
 },
      lcaUpdateForm:false,
      paralegalformerrors:'',
    uploading: false,
    validateLcaFiles: true,
    filedDate: null,
    certifiedDate: null,
    lcaDocuments: [],

    active: false,
    petition: null,
    lcaForm: false,
    lcastatusSelected: {},
    uploadFormsButton: true,
    visaTypeName: "",
    active_tab: 4,
    tabs: [
      {
        index: 0,
      },
      {
        index: 1,
      },
      {
        index: 2,
      },
      {
        index: 3,
      },
      {
        index: 4,
      },
    ],
    lcaDetails: [],
    number: "",
    address: "",
    address2: "",
    certifiedLCA: "",
    lcaStatus: "",
    allLcaStatuses: [],
    formFiles: [],
    certificateFiles: [],
    documentsUploaded: [],
    certificateSignedUrls: "",
    formsAndLetterSignedUrls: [],
    selected_status: "",
    activityList: [],
    uploadCertificateButton: true,
    actioncomment: "",
    documents: [],
    disabled_btn: false,
    currentRole: null,
  }),
  mounted() {
    this.init();
  },
};
</script>
